import * as actionTypes from "./actionTypes";
// import { productTypes } from "../../data";
import { firebase } from "../../firebase/index";
import { collections, documents } from "../../firebase/firestoreNameSpaces";
import { string_to_slug } from "../utility";
//String Similarity check
function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = new Array();
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0) costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}
const similarity = (s1, s2) => {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (
    (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength)
  );
};

//SearchApi
const createSearchSpace = (keywords) => {
  let searchSpace = [];
  keywords.map((keyword) => {
    keyword = keyword.toLowerCase().trim();
    //optimum nutrition gold standard whey protein vanilla ice cream

    let temp = "";
    for (let i = 0; i < keyword.length; i++) {
      temp += keyword.charAt(i);
      searchSpace.push(temp);
    }
    let words = keyword.split("-");
    words = words.filter((word) => {
      if (word) {
        return true;
      }
    });
    // searchSpace =  [...searchSpace,...(words.splice(1,words.length))]
    searchSpace = [...searchSpace, ...words];
    searchSpace = [...new Set(searchSpace)];
  });

  return searchSpace;
};
const similarityProbability = 0.6;

const getProductSearchKeys = async (product) => {
  try {
    let db = firebase.firestore();
    let data = (
      await db
        .collection(collections.K5METADATA)
        .doc(documents.SEARCHKEYS)
        .get()
    ).data();

    let admindata = (
      await db
        .collection(collections.K5METADATA)
        .doc(documents.SEARCHKEYSADMIN)
        .get()
    ).data();

    let searchKeys = data ? (data.keywords ? data.keywords : []) : [];
    let searchKeysAdmin = admindata
      ? admindata.keywords
        ? admindata.keywords
        : []
      : [];

    let searchData = [];
    let productTitles = [];

    let productTitleFlag = false;
    let searchKeyFlag = false;
    let searchKeyAdminFlag = false;

    //Making searchKeysAdmin used to search product for editing in admin panel.
    //comparing productTitles within if variable product
    productTitles.push(string_to_slug(product.productTitle));
    if (product.variable) {
      product.variants.map((variant) => {
        let variantTitle = string_to_slug(variant.productTitle);
        productTitleFlag = false;
        //Comparing Variant Titles and Product Titles for non-similar titles

        for (let i = 0; i < productTitles.length; i++) {
          let title = productTitles[i];
          if (similarity(variantTitle, title) > similarityProbability) {
            productTitleFlag = true;
            break;
          }
        }

        if (!productTitleFlag) {
          productTitles.push(variantTitle);
        }
      });
    }
    //Comparing the productTitles with the adminSearchKeys to get some unique titles.
    let adminKeywords = [];
    productTitles.map((title) => {
      searchKeyAdminFlag = false;

      if (searchKeysAdmin.length) {
        //Comparing searchData with searchKeys
        for (let i = 0; i < searchKeysAdmin.length; i++) {
          let similar = similarity(title, searchKeysAdmin[i]);
          if (similar > similarityProbability) {
            searchKeyAdminFlag = true;
            break;
          }
        }
        if (!searchKeyAdminFlag) {
          adminKeywords.push(title);
        }
      } else {
        adminKeywords.push(title);
      }
    });

    //searchData is making searchKeys for Users.
    searchData.push(
      string_to_slug(product.brand),
      string_to_slug(product.categoryName),
      string_to_slug(product.brand + " " + product.categoryName),
      string_to_slug(product.subcategoryName)
    );
    searchData = searchData.sort((a, b) => a.length - b.length);
    let keywords = [];
    searchData.map((title) => {
      searchKeyFlag = false;

      if (searchKeys.length) {
        //Comparing searchData with searchKeys
        for (let i = 0; i < searchKeys.length; i++) {
          let similar = similarity(title, searchKeys[i]);
          if (similar > similarityProbability) {
            searchKeyFlag = true;
            break;
          }
        }
        if (!searchKeyFlag) {
          keywords.push(title);
        }
      } else {
        keywords.push(title);
      }
    });

    keywords = [...new Set(keywords)]; //For Search Keys (User)
    adminKeywords = [...new Set(adminKeywords)]; //For Search Keys (Admin) //This is done separately to avoid adding productTitle in searchKeys
    searchData = [...new Set([...searchData, ...productTitles])]; //For Search Space

    return { keywords, searchData, adminKeywords };
  } catch (error) {
    return alert(error);
  }
};
const calculateDiscount = (regularPrice, salePrice) => {
  return Math.round(((regularPrice - salePrice) / regularPrice) * 100);
};
const addFilters = (product) => {
  let filters = {};
  if (product.filters) {
    filters = { ...product.filters };
  }
  if (product.variable) {
    let prices = [];
    let discounts = [];
    product.variants.map((variant) => {
      prices.push(variant.salePrice);
      discounts.push(
        calculateDiscount(variant.regularPrice, variant.salePrice)
      );
    });
    prices.sort();
    discounts.sort();
    filters["minPrice"] = prices[0];
    filters["maxPrice"] = prices[prices.length - 1];
    filters["minDiscount"] = discounts[0];
    filters["maxDiscount"] = discounts[discounts.length - 1];
  } else {
    filters["minPrice"] = product.salePrice;
    filters["maxPrice"] = product.salePrice;
    let discount = calculateDiscount(product.regularPrice, product.salePrice);
    filters["minDiscount"] = discount;
    filters["maxDiscount"] = discount;
  }
  product.filters = filters;
  return product;
};
export const onAddSingleProduct = (product) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.PRODUCT_CONTROLS,
        payload: { singleSubmitLoading: true },
      });

      product = addFilters(product);

      let { keywords, searchData, adminKeywords } = await getProductSearchKeys(
        product
      );

      // return console.log(keywords, searchData, adminKeywords);
      let productSearchKeys = keywords;
      let productSearchSpace = createSearchSpace(searchData);
      product["searchSpace"] = productSearchSpace;
      // return console.log(productSearchKeys,productSearchSpace)
      let db = firebase.firestore();
      let batch = db.batch();
      //keywords
      if (productSearchKeys.length) {
        let keywordsRef = db
          .collection(collections.K5METADATA)
          .doc(documents.SEARCHKEYS);
        batch.set(
          keywordsRef,
          {
            keywords: firebase.firestore.FieldValue.arrayUnion(
              ...productSearchKeys
            ),
          },
          { merge: true }
        );
      }

      if (adminKeywords.length) {
        let adminkeywordsRef = db
          .collection(collections.K5METADATA)
          .doc(documents.SEARCHKEYSADMIN);
        batch.set(
          adminkeywordsRef,
          {
            keywords: firebase.firestore.FieldValue.arrayUnion(
              ...adminKeywords
            ),
          },
          { merge: true }
        );
      }

      let productRef = db.collection(collections.PRODUCTS).doc(product.id);
      batch.set(productRef, product, { merge: true });

      await batch.commit();

      dispatch({
        type: actionTypes.PRODUCT_CONTROLS,
        payload: { singleSubmitLoading: false },
      });
      alert("Product Added Successfully");
      return window.location.reload();
    } catch (error) {
      dispatch({
        type: actionTypes.PRODUCT_CONTROLS,
        payload: { singleSubmitLoading: false },
      });
      return alert(error);
    }
  };
};
